/**
 * La forme du classement pendant son premier chargement : sur un téléphone, les deux pilules puis
 * une liste ; au large, deux listes côte à côte sous leur nom. Il mesure sa place par le même
 * crochet et le même seuil que la page. Le cas montré est le cas courant : deux classements.
 */
import React from "react"
import { View } from "react-native"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { useWidthAtLeast } from "../../hooks/useWidthAtLeast"
import { CardList } from "../../molecules/CardList"
import { RankingRowSkeleton } from "../../molecules/RankingRow"
import { RANKING_SIDE_BY_SIDE_FROM, rankingLayoutStyles as styles } from "./rankingLayout"

const ROWS = [0, 1, 2, 3, 4, 5]

function BoardBones() {
    return (
        <CardList>
            {ROWS.map((row) => (
                <RankingRowSkeleton key={row} />
            ))}
        </CardList>
    )
}

export function StudentRankingSkeleton() {
    const { onLayout, atLeast: sideBySide } = useWidthAtLeast(RANKING_SIDE_BY_SIDE_FROM)

    return (
        <View onLayout={onLayout} style={styles.fullWidth}>
            {sideBySide ? (
                <View style={styles.boards}>
                    {[0, 1].map((board) => (
                        <Stack key={board} gap="2" style={styles.board}>
                            <Skeleton textSize="text-xs" width={120} />
                            <BoardBones />
                        </Stack>
                    ))}
                </View>
            ) : (
                <Stack gap="4" style={styles.single}>
                    <View style={styles.pills}>
                        <Skeleton shape="block" height={pushButtonBoxHeight("sm")} radius="md" style={styles.pill} />
                        <Skeleton shape="block" height={pushButtonBoxHeight("sm")} radius="md" style={styles.pill} />
                    </View>
                    <BoardBones />
                </Stack>
            )}
        </View>
    )
}
